<template>
  <div class="loading" v-if="counter.loading">
    <div class="loading-box">
      <loading  color="#1989fa" vertical>加载中...</loading>
    </div>
  </div>
  <router-view v-slot="{ Component }">
    <keep-alive  include="couponMy,couponReceive">
      <component :is="Component"/>
    </keep-alive>
  </router-view>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import { Loading } from 'vant';
import { useSystemStore } from '@/stores/system'
const counter = useSystemStore()
</script>

<style scoped lang="scss">

.aaa {
  font-size: 18px;
  color: $default;
}
.loading {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  right: 0;
  z-index: 999;
  background: rgba(0,0,0,.3);

  .loading-box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%);
  }
}
header {
  
  line-height: 1.5;
  max-height: 100vh;
}

</style>
